export class User {
    userid: number;
    username: string; 
    usertitle: string; 
    deptid: number;
    userroletypeid: number;
    emailid: string;
    password: string;
    createon: Date; 
    modifiedon: Date;
	active: number;
}